import Vue from 'vue'
import api from '@/lib/hippo'
import CourseInterest from '@/models/course_interest';

function initialState() {
    return {
        courseInterests: {}
    };
}

const state = initialState;

const getters = {
    getcourseInterests: (state) => state.courseInterests
};


const actions = {

    fetchCourseInterests({ commit, state, rootGetters }) {
        return new Promise((resolve, reject) => {
                api.getcourseInterests().then((response) => {
                    commit('addcourseInterests', CourseInterest.from(response.data));
                    resolve(true);
                }).catch((err) => reject(err));

        });
    },
};

const mutations = {
    addcourseInterests: (state, courseInterests) => {
        Vue.set(state, 'courseInterests', courseInterests);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}